// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"1c731483","703":"09a04313","787":"c55df8ee"}[chunkId] + ".chunk.js";
};